import React from "react";

import { ButtonLinkStyled } from "../../../../components/common/Buttons/Button.Style";
import LinkRedirect from "../../../../components/common/LinkRedirect";

import { ReactComponent as DeviceIcon } from "../../../../assets/images/habitacional/device-icon.svg";
import OuvidoriaIcon from "../../../../assets/images/icons/ouvidoria.svg";

import * as S from "./OmbudsmanSection.style";

export const OmbudsmanSection = () => {
  return (
    <S.OmbudsmanSectionContainer>
      <S.OmbudsmanSectionContent className="container">
        <S.OmbudsmanSectionBlock>
          <S.OmbudsmanSectionBlockTitle>Ouvidoria</S.OmbudsmanSectionBlockTitle>

          <S.OmbudsmanSectionBlockDescription>
            Já entrou em contato conosco pelos nossos canais de atendimento e
            não resolveu o que precisava? Contate a nossa Ouvidoria. Para isso,
            tenha o número do protocolo do atendimento anterior.
          </S.OmbudsmanSectionBlockDescription>

          <S.OmbudsmanSectionBlockDescription>
            <LinkRedirect
              as={ButtonLinkStyled}
              href="https://www.cshbrasil.com.br/ouvidoria"
              description={
                <>
                  Você será direcionado ao portal de ouvidoria do grupo CNP
                  Seguros Holding, o qual a Caixa Seguradora faz parte, tudo
                  bem?
                </>
              }
            >
              <DeviceIcon width={32} height={32} /> Abrir ocorrência pelo site
            </LinkRedirect>
            Ao clicar no link, encaminharemos você para o site da CNP Seguros
            Holding Brasil, empresa que cuida das nossas operações.
          </S.OmbudsmanSectionBlockDescription>

          <S.OmbudsmanSectionBlockDescription>
            Se preferir, ligue para{" "}
            <a href="tel:0800 274 3000">0800 274 3000</a>. De segunda a sexta,
            das 8h às 18h, exceto em feriados nacionais.
          </S.OmbudsmanSectionBlockDescription>
        </S.OmbudsmanSectionBlock>

        <S.OmbudsmanSectionBlockImage src={OuvidoriaIcon} alt="" />
      </S.OmbudsmanSectionContent>
    </S.OmbudsmanSectionContainer>
  );
};
